export const FETCH_WIDGET_BY_ID = "widget/fetch_by_id";
export const FETCH_WIDGET_BY_ID_DONE = "widget/fetch_by_id_done";
export const FETCH_WIDGET_BY_ID_FAILED = "widget/fetch_by_id_failed";
